import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { CreateUpdateShopifyStoreFormFields } from "../../models/ShopifyStore/CreateUpdateShopifyStore";
import { ShopifyStoreQueryKeys } from "./keys";

export default function useShopifyStoreMutations(customerId: string) {
  const queryClient = useQueryClient();
  const { saveHandlers, deleteHandlers } =
    useDefaultCRUDHandlers("Shopify Store");
  const { post, put, del } = useApiHelper();

  const create = useMutation({
    mutationFn: (store: CreateUpdateShopifyStoreFormFields) =>
      post(`/shopifystore/${customerId}`, store),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ShopifyStoreQueryKeys.all(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const update = useMutation({
    mutationFn: (store: CreateUpdateShopifyStoreFormFields) =>
      put(`/shopifystore/${customerId}/${store.id}`, store),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ShopifyStoreQueryKeys.all(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const remove = useMutation({
    mutationFn: (storeId: string) => del(`/shopifystore/${customerId}/${storeId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ShopifyStoreQueryKeys.all(customerId),
      });
      deleteHandlers.onSuccess();
    },
    onError: () => {
      deleteHandlers.onError();
    },
  });

  return {
    create,
    update,
    remove,
  };
}
